import Link from "next/link";
import LinkButton from "../_atoms/linkbutton";
import { IProjectData } from "@/types/strapi";
import Tag from "../_atoms/tag";
import { getImageUrl } from "@/utils/images";
import Image from "next/image";

function ProjectArticle({
	project,
	horizontal = true,
	className,
}: {
	project: IProjectData;
	horizontal?: boolean;
	className?: string;
}) {
	return (
		<article
			key={project.id}
			className={`${className} rounded-xl border bg-white card-hover ${
				horizontal ? "p-4 " : "overflow-hidden"
			}  relative`}
		>
			<Link
				className={`${
					horizontal ? "lg:flex" : "inline-block"
				} h-full w-full justify-between gap-8 `}
				href={`/projects/${project.slug}`}
			>
				{project.featured_img && (
					<div
						className={`relative ${
							horizontal
								? "lg:w-3/12 shrink-0"
								: "w-full aspect-5/3"
						}`}
					>
						<Image
							src={
								getImageUrl(
									project.featured_img.formats?.large?.url ??
										project.featured_img.url,
								) || "placeholder.png"
							}
							alt={
								project.featured_img.alternativeText ||
								"illustration du projet"
							}
							className={` ${
								horizontal
									? "object-cover object-top"
									: "object-cover object-top"
							}`}
							fill
							quality={75}
							sizes="(max-width: 768px) 100vw, 50vw"
						/>
						{!horizontal &&
							project.tags &&
							project.tags.length > 0 && (
								<div className="flex flex-wrap gap-2 absolute top-4 left-4">
									{project.tags.map((tag) => (
										<Tag key={tag.id} {...tag} />
									))}
								</div>
							)}
					</div>
				)}
				<div className="content grid gap-3">
					<h3
						className={`font-bold text-lg ${
							horizontal ? "" : "p-4"
						}`}
					>
						{project.title}
					</h3>
					{horizontal && project.description_short && (
						<p className="text-base text-muted-foreground">
							{project.description_short}
						</p>
					)}
					{horizontal && project.tags && project.tags.length > 0 && (
						<div className="flex flex-wrap gap-2">
							{project.tags.map((tag) => (
								<Tag key={tag.id} {...tag} />
							))}
						</div>
					)}
					{horizontal && (
						<div className="mt-3">
							<LinkButton text="Voir le projet" />
						</div>
					)}
				</div>
			</Link>
		</article>
	);
}
export default ProjectArticle;
